export enum TitleFontColour {
  PLUM = 'plum',
  GREY = 'grey',
}
